import { AggregationPipeline } from 'types/common/aggregation'

export function getGroupFilterPipeline(groupIds: number[]): AggregationPipeline {
  const groupIdsMatch = groupIds.map(groupId => ({ $eq: ['$groupId', groupId] }))
  const groupFilterPipeline =
    groupIds?.length > 0
      ? [
          {
            $lookup: {
              from: 'GroupsProcess',
              let: {
                processId: '$_id'
              },
              pipeline: [
                {
                  $match: {
                    $expr: {
                      $and: [
                        {
                          $eq: ['$processId', '$$processId']
                        },
                        {
                          $or: [...groupIdsMatch]
                        }
                      ]
                    }
                  }
                }
              ],
              as: 'groupsProcesses'
            }
          },
          {
            $unwind: {
              path: '$groupsProcesses'
            }
          }
        ]
      : []
  return groupFilterPipeline
}
